<template>
  <div class="dashboard">
    <Common />
    <Sidebar />
    <Content />
  </div>
</template>

<script>
import Common from '@/components/common/Common.vue'
import Sidebar from '@/components/dashboard/Sidebar.vue'
import Content from '@/components/dashboard/Content.vue'
export default {
  name: 'DashboardLayout',
  components: { 
    Common,
    Sidebar,
    Content,
  },
}
</script>

<style lang="scss" scoped>
.dashboard {
  display: grid;
  grid-template-columns: 250px calc(100% - 250px);
  grid-template-rows: 65px calc(100% - 65px);
  grid-template-areas: 
    'sideBar            content'
    'sideBar            content'
  ;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: $light-card;
  > .content {
    margin-left: 0px;
  }
}
</style>